import {NgModule} from '@angular/core';
import {InternalErrorComponent} from "./internal-error.component";
import {InternalErrorRoutingModule} from "./internal-error-routing.module";
import {TranslateModule} from "@ngx-translate/core";
import {SharedModule} from "../../shared/shared.module";
import {CommonModule} from "@angular/common";

@NgModule({
    imports: [InternalErrorRoutingModule, TranslateModule, SharedModule, CommonModule],
    declarations: [
        InternalErrorComponent,
    ]
})
export class InternalErrorModule {}


// WEBPACK FOOTER //
// ./public/upgrade/feature/internal-error/internal-error.module.ts